import React, { useEffect, useRef, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { FcEngineering } from "react-icons/fc";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import Pagination from "../../../Components/layouts/pagination";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const CeaNvphHome = () => {
  const [ceaNVPHMaterialList, setCEANVPHMaterialList] = useState([]);
  const [prices, setPrices] = useState([]);
  const [fabricationCharges, setFabricationCharges] = useState([]);
  const [handlingCharges, setHandlingCharges] = useState([]);

  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    productName: "",
  });

  useEffect(() => {
    if (ceaNVPHMaterialList?.length > 0) {
      const initialPrices = ceaNVPHMaterialList.map((item) => ({
        id: item.id,
        price: item.pricePerUnit || "", // or item.price if coming from API
      }));
      setPrices(initialPrices);
      const fabCharges = ceaNVPHMaterialList.map((item) => {
        return {
          id: item.id,
          fabCharges:
            item?.hydroponic_Material_Planning_List?.fabricationChargesMarkup,
        };
      });
      const habCharges = ceaNVPHMaterialList.map((item) => {
        return {
          id: item.id,
          hanCharges: item?.hydroponic_Material_Planning_List?.handlingCharges,
        };
      });
      setHandlingCharges(habCharges);
      setFabricationCharges(fabCharges);
    }
  }, [ceaNVPHMaterialList]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/cea-nvph/get-all-cea-nvph", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setCEANVPHMaterialList(res?.data?.getAllList);
          setTotalPages(Math.ceil(res?.data?.totalListCount / 25));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page, filters]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/cea-nvph/get-all-cea-nvph", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setCEANVPHMaterialList(res?.data?.getAllList);
          setTotalPages(Math.ceil(res?.data?.totalListCount / 25));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page, filters]);

  const handlePriceUpdate = () => {
    setLoading(true);
    performRequest("POST", "/cea-nvph/update-pricing", prices)
      .then((res) => {
        Toast("success", "Data Updated  Successfully");
      })
      .catch((error) => {
        console.log(error);
        CustomErrorResponse(error);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          {" "}
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center d-flex">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcEngineering className="fs-2  me-1" />
                    CEA NVPH PRICING
                  </h2>
                  <h4 className="text-muted">
                    CEA NVPH Centralized System to Modify Per-Unit Item Pricing{" "}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 m-auto">
                  <div className="row">
                    {ceaNVPHMaterialList && (
                      <div className="col-12 col-md-12">
                        <div className="card table-responsive">
                          <div className="card-header text-center fs-2 fw-bold d-flex justify-content-between">
                            <div>Material List-CEA-NVPH PRICE </div>
                            <div className="text-end">
                              <input
                                type="search"
                                className="form-control"
                                placeholder="search by name"
                                value={filters.productName}
                                onChange={(e) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    productName: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <table className="table table-vcenter border">
                            <thead>
                              <tr>
                                <th>Sr</th>
                                <th>Image</th>
                                <th>Item Name</th>
                                <th>Specifications</th>
                                <th>Unit</th>
                                <th>Price/Unit</th>
                                <th>Fabrication</th>
                                <th>Handling</th>
                                {/* <th>Update</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {ceaNVPHMaterialList?.map((item, index) => {
                                const itemId = item?.id;
                                const priceEntry = prices.find(
                                  (p) => p.id === itemId
                                );
                                const fcharges = fabricationCharges.find(
                                  (p) => {
                                    return p.id === itemId;
                                  }
                                );
                                const hcharges = handlingCharges.find((p) => {
                                  return p.id === itemId;
                                });
                                const Index = (page - 1) * 25 + index + 1;
                                return (
                                  <tr key={itemId}>
                                    <td>{Index}</td>
                                    <td>
                                      {item?.hydroponic_Material_Planning_List
                                        ?.image ? (
                                        <LazyImageComponent
                                          src={
                                            item
                                              ?.hydroponic_Material_Planning_List
                                              ?.image
                                          }
                                          alt={
                                            item
                                              ?.hydroponic_Material_Planning_List
                                              ?.itemName
                                          }
                                          width="100"
                                        />
                                      ) : (
                                        "NA"
                                      )}
                                    </td>
                                    <td>
                                      {item?.hydroponic_Material_Planning_List
                                        ?.item || "NA"}
                                      <br />
                                      <span className="badge badge-green badge-outline bg-orange-lt">
                                        {item?.hydroponic_Material_Planning_List
                                          ?.hsn || ""}
                                      </span>
                                      <br />
                                      <span className="badge badge-green badge-outline bg-green-lt mt-1">
                                        GST :{" "}
                                        {item?.hydroponic_Material_Planning_List
                                          ?.gst || ""}
                                      </span>
                                    </td>
                                    <td>
                                      {item?.hydroponic_Material_Planning_List?.specificationsNew?.find(
                                        (el) => el.type === "cea"
                                      )?.specification || "NA"}
                                      <br />
                                      {item?.hydroponic_Material_Planning_List?.fabricationProcess?.map(
                                        (el, idx) => {
                                          // list of Tabler colors
                                          const colors = [
                                            "bg-green-lt",
                                            "bg-blue-lt",
                                            "bg-yellow-lt",
                                            "bg-orange-lt",
                                            "bg-purple-lt",
                                            "bg-pink-lt",
                                            "bg-teal-lt",
                                            "bg-cyan-lt",
                                          ];

                                          // pick color based on index
                                          const colorClass =
                                            colors[idx % colors.length];

                                          return (
                                            <span
                                              key={idx}
                                              className={`me-2 badge badge-outline mt-1 ${colorClass}`}
                                            >
                                              {el}
                                            </span>
                                          );
                                        }
                                      )}
                                    </td>

                                    <td>
                                      {item?.hydroponic_Material_Planning_List
                                        ?.unit || "NA"}
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        style={{ width: 80 }}
                                        value={priceEntry?.price || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setPrices((prevPrices) => {
                                            const exists = prevPrices.find(
                                              (p) => p.id === itemId
                                            );
                                            if (exists) {
                                              return prevPrices.map((p) =>
                                                p.id === itemId
                                                  ? { ...p, price: value }
                                                  : p
                                              );
                                            } else {
                                              return [
                                                ...prevPrices,
                                                { id: itemId, price: value },
                                              ];
                                            }
                                          });
                                        }}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        style={{ width: 80 }}
                                        value={fcharges?.fabCharges || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setFabricationCharges(
                                            (prevFabCharges) => {
                                              const exists =
                                                prevFabCharges.find(
                                                  (p) => p.id === itemId
                                                );
                                              if (exists) {
                                                return prevFabCharges.map((p) =>
                                                  p.id === itemId
                                                    ? {
                                                        ...p,
                                                        fabCharges: value,
                                                      }
                                                    : p
                                                );
                                              } else {
                                                return [
                                                  ...prevFabCharges,
                                                  {
                                                    id: itemId,
                                                    fabCharges: value,
                                                  },
                                                ];
                                              }
                                            }
                                          );
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        style={{ width: 80 }}
                                        value={hcharges?.hanCharges || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setHandlingCharges((hanCharges) => {
                                            const exists = hanCharges.find(
                                              (p) => p.id === itemId
                                            );
                                            if (exists) {
                                              return hanCharges.map((p) =>
                                                p.id === itemId
                                                  ? {
                                                      ...p,
                                                      hanCharges: value,
                                                    }
                                                  : p
                                              );
                                            } else {
                                              return [
                                                ...hanCharges,
                                                {
                                                  id: itemId,
                                                  hanCharges: value,
                                                },
                                              ];
                                            }
                                          });
                                        }}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          <Pagination
                            page={page}
                            setPage={setPage}
                            totalPages={totalPages}
                            pageDatalength={ceaNVPHMaterialList?.length}
                            showPage={showPage}
                            setShowPage={setShowPage}
                          />
                        </div>
                        <div className="footer text-end mt-0">
                          <button
                            className="btn btn-primary text-end"
                            onClick={handlePriceUpdate}
                          >
                            Update Prices
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CeaNvphHome;
